import { createSelector } from 'reselect';

const projectEditData = state => state.projectEditPopupData;

export const isProjectEditPopupOpenedSelector = createSelector(
    projectEditData,
    (popupData) => popupData.isOpened,
);
